import { defineMessages } from 'react-intl';

export const customerReviewCardActionsMenuMessages = defineMessages({
  actionsMenuAriaLabel: {
    id: 'customerReviews.reviewCard.actionsMenu.aria.label',
    defaultMessage: 'Optionen zu dieser Bewertung',
  },
  actionsMenuReportText: {
    id: 'customerReviews.reviewCard.actionsMenu.report.text',
    defaultMessage: 'Bewertung melden',
  },
  actionsMenuReportSuccess: {
    id: 'customerReviews.reviewCard.actionsMenu.report.success',
    defaultMessage: 'Vielen Dank für deine Einschätzung.',
  },
  actionsMenuReportError: {
    id: 'customerReviews.reviewCard.actionsMenu.report.error',
    defaultMessage: 'Feedback konnte nicht abgegeben werden.',
  },
});
